export default __webpack_public_path__ + "static/media/baunebakken-floorplan-3-rooms.de7e8e0c.png";